<template>
  <div v-if="loaded && currentUserIsOwner">
    <ConnectRequestsList
      v-if="currentUserIsOwner"
      :requests="requests"
      :userID="userID"
      :sentRequests="true"
    />
    <br/>
    <div v-if="!allLoaded">
      <button @click="loadMoreRequests" class="border">
        Load more requests 
      </button>
    </div>
    <div v-else class="all-loaded">
      All Loaded!
    </div>
  </div>
</template>
<script>
import ConnectRequestsList from "./ConnectRequestsList";

import profileAPIService from "../../../api/profileAPIService";

import { NR_CONNECTS_TO_LOAD } from "../constants";

export default {
  name: "ProfileTabSent",
  components: {
    ConnectRequestsList,
  },
  props: {
    badges: Array,
    userID: String,
    profileOwnerID: String,
    currentUserIsOwner: Boolean,
  },
  data() {
    return {
      allLoaded: false,
      loaded: false,
      requests: []
    };
  },
  methods: {
    async loadMoreRequests() {
      const result = await profileAPIService.getConnectRequests(this.userID, NR_CONNECTS_TO_LOAD, this.requests.length, true);
      console.log("@ProfileTabReceived loaded requests, requests: ", result);
      console.log("RESULT LENGTH: ", result.requests.length);
      if (result !== null) {
        this.requests = this.requests.concat(result.requests);
        if (result.requests.length < NR_CONNECTS_TO_LOAD) {
          console.log("HERE!!", result.requests.length, result.requests.length === 0);
          this.allLoaded = true;
        }
      }
      this.loaded = true;
    }
  },
  created() {
    if (this.currentUserIsOwner) {
      this.loadMoreRequests();
    }
  }
}
</script>
<style scoped>
.all-loaded {
  font-weight: 700px;
  font-size: 17px;
  text-align: center;
}
</style>